module.exports = __webpack_public_path__ + "static/media/clydeNatGuard.39cd1dfd.png";